import { createContext } from "react";

export const JourneyContext = createContext<any>({});
